import { css } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { MOBILE } from '../../../utils/constants';

interface Props {
  views: number;
  likesInfo?: {
    count: number;
    likedBy?: string;
  };
}

const PostActions = ({ views, likesInfo }: Props) => {
  return (
    <div css={containerStyles} data-testid="post-actions">
      <div css={leftActionsStyles}>
        <button css={secondaryButtonStyles} data-testid="watch-button">
          <span css={iconStyles}>{'\ud83d\udc41'}</span>
          {'Watch'}
        </button>
        <button css={secondaryButtonStyles} data-testid="like-button">
          <span css={iconStyles}>{'\ud83d\udc4d'}</span>
          {'Like'}
        </button>
        {likesInfo && likesInfo.count > 0 && (
          <span css={likesInfoStyles} data-testid="likes-info">
            <strong>{likesInfo.likedBy}</strong> {' likes this'}
          </span>
        )}
        <button css={secondaryButtonStyles} data-testid="share-button">
          <span css={iconStyles}>{'\ud83d\udd17'}</span>
          {'Share'}
        </button>
      </div>
      <div css={viewsStyles} data-testid="views-count">
        {views} {'views'}
      </div>
    </div>
  );
};

const containerStyles = css({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  paddingTop: '16px',
  borderTop: `1px solid ${token('color.border')}`,
  gap: '16px',
  fontFamily: 'Inter, sans-serif',
  [MOBILE.MEDIA_QUERY]: {
    gap: '8px',
    paddingTop: '12px',
  },
});

const leftActionsStyles = css({
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  flexWrap: 'wrap',
  [MOBILE.MEDIA_QUERY]: {
    gap: '8px',
  },
});

const secondaryButtonStyles = css({
  backgroundColor: 'transparent',
  color: token('color.text.subtle'),
  border: 'none',
  borderRadius: '4px',
  padding: '8px 12px',
  fontSize: '14px',
  fontWeight: 500,
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  fontFamily: 'Inter, sans-serif',
  transition: 'background 0.2s, color 0.2s',
  '&:hover': {
    backgroundColor: token('color.background.neutral.hovered'),
    color: token('color.text'),
  },
  [MOBILE.MEDIA_QUERY]: {
    fontSize: '13px',
    padding: '7px 10px',
  },
});

const iconStyles = css({
  fontSize: '14px',
  [MOBILE.MEDIA_QUERY]: {
    fontSize: '13px',
  },
});

const likesInfoStyles = css({
  fontSize: '14px',
  color: token('color.text.subtle'),
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  [MOBILE.MEDIA_QUERY]: {
    fontSize: '13px',
  },
});

const viewsStyles = css({
  fontSize: '14px',
  color: token('color.text.subtle'),
  fontWeight: 500,
  [MOBILE.MEDIA_QUERY]: {
    fontSize: '13px',
  },
});

export default PostActions;
